import type { oz } from '@weft/utils';
import { InstallmentsPricingSchema } from './installments-pricing-schema';

export const InstallmentsPricingInputSchema = InstallmentsPricingSchema
  .deepPartial()
  .required({ pricingModel: true })
  .openapi('InstallmentsPricingInput');

export type InstallmentsPricingInput = oz.infer<typeof InstallmentsPricingInputSchema>;